module.exports = __webpack_public_path__ + "static/media/logo.ae02adc1.jpg";